var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "add-to-group"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0c1.2244049 0 2.2432259.88020914 2.4582104 2.04237481 1.0132189.18695447 1.8124603.9861959 2 2 1.1091594.20470213 1.9618098 1.14294513 2.0364719 2.2932495L16 6.5v5c0 1.3254834-1.0315359 2.4100387-2.3356243 2.4946823L13.5 14h-5c-.08402779 0-.16708733-.0041455-.24898526-.0122433.20241764-.3056932.36857072-.636211.49254061-.9866648L13.5 13c.7796961 0 1.4204487-.5948881 1.4931334-1.35554L15 11.5v-5c0-.6528467-.4170681-1.20828193-.999297-1.41439849L14 9.5c0 1.3254834-1.0315359 2.4100387-2.3356243 2.4946823L11.5 12l-2.52754265.0007074C8.99065656 11.8363124 9 11.6692473 9 11.5c0-.1689026-.00930542-.3356318-.02743156-.499703L11.5 11c.7796961 0 1.4204487-.5948881 1.4931334-1.35553999L13 9.5v-5c0-.6528467-.4170681-1.20828193-.999297-1.41439849L12 7.5c0 1.3254834-1.0315359 2.41003867-2.33562431 2.49468232L9.5 10l-.75608915-.00008655c-.1257671-.35580457-.29501192-.69107032-.50135085-.99941364L9.5 9c.7796961 0 1.4204487-.59488808 1.4931334-1.35553999L11 7.5v-5c0-.82842712-.6715729-1.5-1.5-1.5h-5c-.77969612 0-1.42044868.59488808-1.49313342 1.35553999L3 2.5l-.00008655 4.75608915c-.35082701.12400767-.68168583.2902851-.98645705.49271285-.00369216-.02488767-.00580065-.05006728-.00753325-.07535021L2 7.5v-5C2 1.1745166 3.03153594.08996133 4.33562431.00531768L4.5 0h5Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 4.5,
    cy: 11.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    d: "M4.5 9.5v4M2.5 11.5h4"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "add-tag"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .181981)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98528137 0c.39782474 0 .77935561.15803526 1.06066018.43933983l6.27309835 6.27309832c.5857864.58578644.5857864 1.5355339 0 2.12132034l-4.2426407 4.24264071c-.5857865.5857864-1.53553393.5857864-2.12132036 0l-.22353381-.2237613c.13328316-.3674356.22007124-.7571627.25325398-1.1620712l.67738661.6787257c.19526214.1952621.51184468.1952621.70710678 0l4.2426407-4.24264069c.1952621-.19526214.1952621-.51184463 0-.70710678L8.33883476 1.14644661C8.24506658 1.05267842 8.11788962 1 7.98528137 1H3.74264069c-.27614238 0-.5.22385763-.5.5v4.24264069c0 .13260824.05267842.2597852.14644661.35355339l.73760021.73708917c-.40463426.03322933-.79410184.11999201-1.16130591.25319121l-.28340108-.2831736c-.28130457-.28130457-.43933983-.66283544-.43933983-1.06066017V1.5c0-.82842713.67157287-1.5 1.5-1.5Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 4.5,
    cy: 11.3180195,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 6,
    cy: 3.81801948,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.318019v4M2.5 11.318019h4"
  })))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 15",
    id: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 8.5h4.9L3.6 14l6.1-8.5H4.9L6.1 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "calendar"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M4.5 2.5h-4v21h23v-21h-4"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M4.5.5h3v4h-3zM16.5.5h3v4h-3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.5 2.5h9"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M.5 7.5h23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M6.5 9.5v12M11.5 9.5v12M16.5 9.5v12M2.5 11.5h19M2.5 15.5h19M2.5 19.5h19"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 8 6",
    id: "checked"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.9 1.3L3.6 5.7c-.2.1-.4.2-.6.2h-.3c-.2 0-.4-.1-.5-.2l-2-2c-.1-.1-.1-.3 0-.4l.8-.8c.1-.1.3-.1.4 0l1.3 1.3c.1.1.3.1.4 0L6.7.2c.1-.2.3-.2.4-.1l.8.8c.1.1.1.3 0 .4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 11",
    id: "favourite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.13l1.43 2.9 3.2.47-2.31 2.25.54 3.19L6 8.44l-2.86 1.5.54-3.19L1.37 4.5l3.2-.47L6 1.13z",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 11",
    id: "favourited"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9l-3.53 1.85.68-3.92L.29 4.15l3.95-.58L6 0l1.76 3.57 3.95.58-2.86 2.78.68 3.92z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "group",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0c1.2244049 0 2.2432259.88020914 2.4582104 2.04237481 1.0132189.18695447 1.8124603.9861959 2 2 1.1091594.20470213 1.9618098 1.14294513 2.0364719 2.2932495L16 6.5v7c0 1.3254834-1.0315359 2.4100387-2.3356243 2.4946823L13.5 16h-7c-1.22440487 0-2.24322588-.8802091-2.45821043-2.0423748-1.01321886-.1869545-1.81246029-.9861959-2-2C.88020914 11.7432259 0 10.7244049 0 9.5v-7C0 1.11928813 1.11928813 0 2.5 0Zm4.500703 5.08560151L14 11.5c0 1.3254834-1.0315359 2.4100387-2.3356243 2.4946823L11.5 14l-6.41439849.000703c.19073122.5387691.68057841.9361136 1.26993848.9924304L6.5 15h7c.7796961 0 1.4204487-.5948881 1.4931334-1.35554L15 13.5v-7c0-.6528467-.4170681-1.20828193-.999297-1.41439849ZM13 4.5c0-.6528467-.4170681-1.20828193-.999297-1.41439849L12 9.5c0 1.3807119-1.1192881 2.5-2.5 2.5l-6.41439849.000703c.19073122.5387691.68057841.9361136 1.26993848.9924304L4.5 13h7c.7796961 0 1.4204487-.5948881 1.4931334-1.35554L13 11.5v-7ZM9.5 1h-7C1.67157288 1 1 1.67157288 1 2.5v7c0 .8284271.67157288 1.5 1.5 1.5h7c.8284271 0 1.5-.6715729 1.5-1.5v-7c0-.82842712-.6715729-1.5-1.5-1.5Z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    id: "ungroup",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.000703 4.08560151C13.5829319 4.29171807 14 4.8471533 14 5.5v7l-.0068666.14446C13.9204487 13.4051119 13.2796961 14 12.5 14h-7l-.14446-.0068666c-.5893601-.0563168-1.0792073-.4536613-1.2699385-.9924304L10.5 13l.1643757-.0053177C11.9684641 12.9100387 13 11.8254834 13 10.5Zm-2-2C11.5829319 2.29171807 12 2.8471533 12 3.5v7l-.0068666.14446C11.9204487 11.4051119 11.2796961 12 10.5 12h-7l-.14446-.0068666c-.5893601-.0563168-1.0792073-.4536613-1.2699385-.9924304L8.5 11l.1643757-.0053177C9.9684641 10.9100387 11 9.8254834 11 8.5ZM8.5 0c.8284271 0 1.5.67157288 1.5 1.5v7l-.0068666.14446001C9.9204487 9.4051119 9.2796961 10 8.5 10h-7l-.14446-.0068666C.5948881 9.9204487 0 9.2796961 0 8.5v-7l.0068666-.14446001C.0795513.59488808.7203039 0 1.5 0Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 11 17",
    id: "logo",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.3c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5S11 7.8 11 10.8s-2.5 5.5-5.5 5.5m0-9.9c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4.1c2.1 0 3.4.9 4.7 2.3l.6-6.4S9.4 2.5 8.2 2.5C7 2.5 5.6 0 5.6 0S4.3 2.5 3 2.5.3 0 .3 0l.4 6.3C2 4.8 3.5 4.1 5.6 4.1M5.7 11.5c0 .2-.1.3-.3.3H5c-.2 0-.3-.1-.3-.3V8.1c0-.1.1-.3.3-.3h.3c.2 0 .3.1.3.3v3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 11.5c0 .2-.1.3-.3.3H5c-.2 0-.3-.1-.3-.3v-.4c0-.2.1-.3.3-.3h2.8c.2 0 .3.1.3.3v.4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "magic-wand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15.2 14.9",
    id: "pencil-single"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.4,13.8l-3.7,0.5l0.6-3.6l9.5-9.5c0.9-0.9,2.3-0.9,3.2,0c0,0,0,0,0,0c0.9,0.9,0.9,2.3,0,3.2c0,0,0,0,0,0 L4.4,13.8z M9.9,2.4l3,3"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0zm7.8 16.8l-8.6 8.7c-.2.2-.7.5-1.1.5h-.7c-.4 0-.8-.2-1.1-.5l-4.1-4.1c-.2-.2-.2-.7 0-.9l1.6-1.6c.2-.2.7-.2.9 0l2.6 2.6c.2.2.7.2.9 0l7.1-7.1c.2-.2.7-.3.9 0l1.6 1.6c.3.1.3.5 0 .8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 12",
    id: "pin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.5 11.4c.5.4 1 .6 1.6.6.6 0 1.1-.2 1.5-.6l3-3c.4-.5.6-1 .6-1.6 0-.6-.2-1.1-.6-1.5l-.9-.9-.8.8.9.9c.2.2.3.5.3.7 0 .3-.1.5-.3.7l-3 3c-.4.4-1 .4-1.4 0l-1-.9c-.4-.3-.4-1 0-1.4l1.5-1.5-.8-.8L.6 7.4c-.8.8-.8 2.2 0 3l.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.1 1C9.7.6 9.1.4 8.6.4 8 .4 7.5.6 7 1L4 4c-.4.4-.6 1-.6 1.5 0 .6.2 1.1.6 1.5l.9 1 .8-.8-.9-.9c-.2-.2-.3-.5-.3-.8s.1-.5.3-.7l3-3c.2-.2.5-.3.8-.3.3 0 .5.1.7.3l.9.9c.2.2.3.4.3.7 0 .3-.1.5-.3.7L8.7 5.7l.8.8L11 5c.4-.4.6-.9.6-1.5S11.4 2.4 11 2l-.9-1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 200 200",
    id: "posted"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M108 164c-1.4 0-2.9-.5-4.1-1.6l-36-33c-1.2-1.1-1.9-2.7-1.9-4.4V92c0-3.3 2.7-6 6-6s6 2.7 6 6v30.4l34.1 31.2c2.4 2.2 2.6 6 .4 8.5-1.3 1.2-2.9 1.9-4.5 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M200 57c0-31.5-25.5-57-57-57-29.4 0-53.6 22.3-56.7 50.9-3.7-.6-7.4-.9-11.3-.9-41.4 0-75 33.6-75 75s33.6 75 75 75 75-33.6 75-75c0-3.9-.3-7.6-.9-11.3C177.7 110.6 200 86.4 200 57zM75 188c-34.7 0-63-28.3-63-63s28.3-63 63-63c3.9 0 7.6.4 11.3 1 2.8 26.7 24 47.8 50.6 50.6.7 3.7 1 7.5 1 11.3.1 34.8-28.2 63.1-62.9 63.1zM175.9 43.5l-36.3 36.4c-1 1.1-3.1 1.9-4.6 1.9h-3.1c-1.5 0-3.5-.9-4.6-1.9l-17.1-17.2c-1-1.1-1-2.8 0-3.8l6.7-6.7c1-1.1 2.8-1.1 3.8 0L131.6 63c1 1 2.8 1 3.8 0l30-30c1-1 2.8-1.1 3.8 0l6.7 6.7c1 1 1 2.7 0 3.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 7 6.9",
    id: "remove"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M1 5.9L5.9 1M6 5.9L1 1",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26 26",
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M15.2 15.2l9.3 9.3"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "search-thin"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-533 -174)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(533 174)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-23.03 9.5 9.49)",
    cx: 9.49,
    cy: 9.49,
    r: 6.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 14.24l5.2 5.2"
  })))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    id: "success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0zm-6.7 25.9h-.7c-.4 0-.8-.2-1.1-.5l-4.1-4.1c-.2-.2-.2-.7 0-.9L9 18.8c.2-.2.7-.2.9 0l2.6 2.6c.2.2.7.2.9 0l7.1-7.1c.2-.2.7-.3.9 0l1.6 1.6c.2.2.3.7 0 .9l-8.6 8.7c-.2.2-.7.4-1.1.4zm20.3-9.1L25 25.4c-.2.2-.7.5-1.1.5h-.7c-.4 0-.8-.2-1.1-.5l-2.5-2.5 2.5-2.5 1.1 1.1c.2.2.7.2.9 0l7.1-7.1c.2-.2.7-.3.9 0l1.6 1.6c.1.1.1.5-.1.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17 17",
    id: "tag"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "currentColor",
    d: "M7.4.4h-7v7l9 9 7-7-9-9zM4.5 6.2c-.9 0-1.6-.7-1.6-1.6S3.6 3 4.5 3s1.6.7 1.6 1.6-.7 1.6-1.6 1.6z",
    transform: "translate(.5 .5)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "activity-type",
    viewBox: "0 0 8.7 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 0c1 0 1.8.2 2.5.5s1.1.7 1.1 1.3c0 .3-.1.5-.3.7-.2.1-.4.2-.6.2-.3 0-.7-.2-1.2-.7-.4-.5-.8-.9-1.1-1.1C4.3.7 4 .6 3.5.6s-.9.1-1.3.4c-.3.2-.5.5-.5.8 0 .3.1.6.4.9.3.3 1 .8 2.2 1.6 1.3.9 2.2 1.5 2.7 2 .4.4.8.9 1.1 1.4.4.7.6 1.5.6 2.3 0 1.3-.5 2.5-1.4 3.5-1 1-2.1 1.5-3.4 1.5-1.1 0-1.9-.6-2.7-1.3-.3-.4-1-1.3-1.1-2.2C0 10.3 0 11 0 9.8c0-.3.8-2.1 1.1-2.4.9-.9 2-1.4 3.3-1.6-.4-.3-.9-.8-1.5-1.3-.8-.6-1.2-1.1-1.5-1.4C1.2 2.7 1 2.4 1 2c0-.6.3-1.1.9-1.4C2.5.2 3.3 0 4.3 0zm.6 6.4c-2.1.3-3.2 1.6-3.2 4 0 1.2.3 2.2.8 2.9.5.7 1.1 1 1.8 1s1.3-.3 1.8-1 .7-1.6.7-2.7c0-1.6-.7-3-1.9-4.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "add-activity"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.527995 0c.9599099 0 1.7963205.15559816 2.5094777.46614947.7131571.31055132 1.072351.7389325 1.079881 1.28449855 0 .26236637-.0877623.47981612-.261918.65299926-.1741539.17253313-.377782.25911637-.610914.25911637-.3345853 0-.7274624-.23828306-1.1786137-.71484919-.4580144-.48371612-.8440285-.82161574-1.1566732-1.01563218-.3126447-.19336645-.6835812-.29361634-1.1127919-.300133-.5382292 0-.97841023.11393154-1.31985857.34179962-.34144834.22786807-.51697311.51758274-.52383613.87044901 0 .33138296.14192758.64193261.425788.93229894.28317411.29036634 1.0140593.81836574 2.1926555 1.58528154 1.2581615.82161574 2.1454393 1.46419834 2.6616576 1.92649782.5162886.46288281.941392 1.02538217 1.2759773 1.68883142.3345854.66276591.4984553 1.36393178.4909253 2.10283097 0 1.2981818-.479955 2.4413305-1.4405318 3.4283294-.9592078.9876326-2.086463 1.4843655-3.3809582 1.491532-1.1251964 0-2.08206677-.3666204-2.87165434-1.0998614C8.74633364 13.2044737 9 12.3818603 9 11.5c0-1.2639431-.52109669-2.40617754-1.36017273-3.22358599.18784166-.30314104.41849671-.58613582.69100156-.84930576.88722507-.8561157 1.98553627-1.37434844 3.29459997-1.55338157-.3635293-.38676623-.8688476-.84966571-1.5160952-1.3880651-.7130694-.59374932-1.19302434-1.0598988-1.44053182-1.39843175-.24682294-.33853295-.37093651-.71484919-.37093651-1.12889872 0-.60741597.2982517-1.0839821.89477264-1.4296817C9.7891413.18359978 10.5673479.00716665 11.527995 0Zm.5779329 6.3502428-.0001229.00016667c-2.0871651.3242163-3.13136194 1.68483142-3.13136194 4.08132873 0 1.2363319.25849534 2.1959975.7747839 2.8794967.51628854.6835992 1.12307774 1.0253825 1.82177164 1.0253825.7199324 0 1.313013-.3281333 1.7785925-.9837159.4648598-.6562492.6979918-1.5507815.6979918-2.6829969 0-1.63019818-.6472476-3.06966321-1.941655-4.3196618Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 4.5,
    cy: 11.3180195,
    r: 4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.318019v4M2.5 11.318019h4"
  })))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19 19",
    id: "timezone"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 0.808,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 13.656,
    cy: 13.656,
    r: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.808,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.756 13.656h-2.1v-2.098m-5.348 6.769a8.907 8.907 0 1 1 7.4-15.215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.354 18.146c-1.204-1.767-2.01-4.978-2.01-8.646 0-3.668.806-6.878 2.01-8.646M.614 8.906h7.539m-5.779-4.75H7.92m-6.299 9.5h4.91M11.646.854c.31.523.583 1.065.818 1.622",
    stroke: "currentColor",
    strokeWidth: 0.808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.775 7.371c1.67.027 3.237.869 4.259 2.287l.491-6.333s-1.31 2.463-2.375 2.463-2.375-2.463-2.375-2.463-1.228 2.463-2.375 2.463-2.375-2.463-2.375-2.463l.328 6.07c1.113-1.359 2.739-2.103 4.422-2.024z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "trash-wide"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5v11c0 .5522847-.44771525 1-1 1h-9c-.5522847 0-1-.4477153-1-1v-11M11.5 3.5v-2c0-.55228475-.44771525-1-1-1h-5c-.55228475 0-1 .44771525-1 1v2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5 3.5h15M6.5 6.5v6M9.5 6.5v6"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    id: "trash-large"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5v10c0 .5522847-.44771525 1-1 1h-7c-.5522847 0-1-.4477153-1-1v-10M10.5 2.5v-1c0-.55228475-.44771525-1-1-1h-5c-.55228475 0-1 .44771525-1 1v1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5 2.5h13M5.5 5.5v5M8.5 5.5v5"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "trash"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.5v10c0 .5522847-.44771525 1-1 1h-7c-.5522847 0-1-.4477153-1-1v-10M11.5 3.5v-1c0-.55228475-.44771525-1-1-1h-5c-.55228475 0-1 .44771525-1 1v1",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    d: "M1.5 3.5h13M6.5 6.5v5M9.5 6.5v5"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 448 512",
    id: "trash-restore"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 12",
    id: "unfavourite"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 3.94l5.51 5.7L6 9l-3.53 1.85.68-3.92L.35 4.2v-.06l1.37-.2zM6 0l1.76 3.57 3.95.58-2.86 2.78.4 2.32-5.6-5.6.59-.08L6 0z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    d: "M1.5 1.5l9 9M1.5 1.5l9 9"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 200 200",
    id: "unposted"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M75 62c-34.7 0-63 28.3-63 63s28.3 63 63 63 63-28.3 63-63c0-5.1-.6-10-1.7-14.7-1.9-7.8-5.2-15-9.7-21.4L139 86c7 11.4 11 24.7 11 39 0 41.4-33.6 75-75 75S0 166.4 0 125s33.6-75 75-75v12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M108 164c-1.4 0-2.9-.5-4.1-1.6l-36-33c-1.2-1.1-1.9-2.7-1.9-4.4V92c0-3.3 2.7-6 6-6s6 2.7 6 6v30.4l34.1 31.2c2.4 2.2 2.6 6 .4 8.5-1.3 1.2-2.9 1.9-4.5 1.9zM126.6 77.7c-16.8 0-30.2-13.4-30.2-30.2s13.4-30.2 30.2-30.2 30.2 13.4 30.2 30.2-13.4 30.2-30.2 30.2zm0-77.7C83.4 0 53.2 47.5 53.2 47.5S75.2 95 126.6 95c51.8 0 73.4-47.5 73.4-47.5S170.2 0 126.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M139.5 47.5c0 7.2-5.8 13-13 13s-13-5.8-13-13 5.8-13 13-13 13 5.8 13 13"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "untagged"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .182)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.985 0a1.5 1.5 0 0 1 1.06.44l6.274 6.272a1.5 1.5 0 0 1 0 2.122l-4.243 4.242a1.5 1.5 0 0 1-2.12 0l-.224-.223c.133-.368.22-.758.253-1.162l.677.678a.5.5 0 0 0 .707 0l4.243-4.242a.5.5 0 0 0 0-.707L8.339 1.146A.5.5 0 0 0 7.985 1H3.743a.5.5 0 0 0-.5.5v4.243a.5.5 0 0 0 .146.353l.738.737c-.405.034-.794.12-1.162.253l-.283-.283a1.5 1.5 0 0 1-.44-1.06V1.5a1.5 1.5 0 0 1 1.5-1.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 4.5,
    cy: 11.318,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 6,
    cy: 3.818,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.086 13.733 4.95-4.95",
    stroke: "currentColor",
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23 23",
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21.5l20-20M1.5 1.5l20 20"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "bell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "list",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "collection-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "circle-fill"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "circle-half"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 8 5",
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74 4.239.24 1.048.553.76 3.74 3.664 6.924.76l.315.287z",
    fillRule: "nonzero",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "currentColor",
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "info-circle",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "collapse-groups",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3076923 0C15.242328 0 16 .75767196 16 1.69230769V2.004l.0433825.00186833c1.0482773.07778206 1.8839069.91951546 1.9521179 1.97042917L17.996 4.004l.0473825.00186833c1.0482773.07778206 1.8839069.91951546 1.9521179 1.97042917L20 6.11538462v6.76923078c0 1.1215629-.8728381 2.0392635-1.9762975 2.110885L17.8846154 15h-6.7692308L11 14.996V18c0 1.1045695-.8954305 2-2 2H2c-1.1045695 0-2-.8954305-2-2v-7c0-1.1045695.8954305-2 2-2h3V1.69230769C5 .75767196 5.75767196 0 6.69230769 0h7.61538461ZM5.28289324 12.6941091l-.06047336.0537515-2.5 2.7522486c-.11133701.1225708-.12724229.30045-.04771586.4388233l.04771586.0654555.22504456.2477514c.13020024.1433374.34366941.1612545.49468689.0537515l.06047335-.0537515L5.5 14.054l1.99741044 2.1981781c.11160681.1228335.284369.1535317.42654389.0921012l.06811376-.0383926.06046747-.0537473.22504456-.2477514c.11133701-.1225709.12724229-.3004501.04771586-.4388233l-.04771586-.0654555-2.5-2.7522486c-.13020024-.1433374-.34366941-.1612545-.49468688-.0537515ZM18.0068508 4.85196403 18 4.851v6.0336154c0 1.1215629-.8728381 2.0392635-1.9762975 2.110885L15.8846154 13H11v1.148l.1153846.0058462h6.7692308c.6597429 0 1.2019181-.5033669 1.2634206-1.1469954l.0058102-.1222354V6.11538462c0-.65974287-.5033669-1.20191812-1.1469954-1.26342059Zm-2-2L16 2.851v6.45669231C16 10.242328 15.242328 11 14.3076923 11H11v1.153l4.8846154.0008462c.6597429 0 1.2019181-.5033669 1.2634206-1.1469954l.0058102-.1222354V4.11538462c0-.65974287-.5033669-1.20191812-1.1469954-1.26342059ZM14.3076923.84615385H6.69230769c-.43393802 0-.79158298.32664939-.84046115.74747443l-.00569269.09867941L5.846 9H9c.80211829 0 1.4939492.47219635 1.812681 1.1537773l3.4950113.0000689c.433938 0 .791583-.32664944.8404612-.74747448l.0056927-.09867941V1.69230769c0-.43393802-.3266494-.79158298-.7474745-.84046115l-.0986794-.0056927Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "expand-groups",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3076923 0C15.242328 0 16 .75767196 16 1.69230769V2.004l.0433825.00186833c1.0482773.07778206 1.8839069.91951546 1.9521179 1.97042917L17.996 4.004l.0473825.00186833c1.0482773.07778206 1.8839069.91951546 1.9521179 1.97042917L20 6.11538462v6.76923078c0 1.1215629-.8728381 2.0392635-1.9762975 2.110885L17.8846154 15h-6.7692308L11 14.996V18c0 1.1045695-.8954305 2-2 2H2c-1.1045695 0-2-.8954305-2-2v-7c0-1.1045695.8954305-2 2-2h3V1.69230769C5 .75767196 5.75767196 0 6.69230769 0h7.61538461ZM7.49741044 12.7478219 5.5 14.946l-1.99737532-2.1981394c-.14880027-.1638141-.40635997-.1638141-.55516024 0l-.22504456.2477514c-.12989317.1429994-.12989317.3612795 0 .5042788l2.5 2.7522486c.14880027.1638141.40635997.1638141.55516024 0l2.5-2.7522486c.12989317-.1429993.12989317-.3612794 0-.5042788l-.22504456-.2477514-.06046747-.0537473c-.15100249-.1074966-.3644497-.0895971-.49465765.0537086ZM18.0068508 4.85196403 18 4.851v6.0336154c0 1.1215629-.8728381 2.0392635-1.9762975 2.110885L15.8846154 13H11v1.148l.1153846.0058462h6.7692308c.6597429 0 1.2019181-.5033669 1.2634206-1.1469954l.0058102-.1222354V6.11538462c0-.65974287-.5033669-1.20191812-1.1469954-1.26342059Zm-2-2L16 2.851v6.45669231C16 10.242328 15.242328 11 14.3076923 11H11v1.153l4.8846154.0008462c.6597429 0 1.2019181-.5033669 1.2634206-1.1469954l.0058102-.1222354V4.11538462c0-.65974287-.5033669-1.20191812-1.1469954-1.26342059ZM14.3076923.84615385H6.69230769c-.43393802 0-.79158298.32664939-.84046115.74747443l-.00569269.09867941L5.846 9H9c.80211829 0 1.4939492.47219635 1.812681 1.1537773l3.4950113.0000689c.433938 0 .791583-.32664944.8404612-.74747448l.0056927-.09867941V1.69230769c0-.43393802-.3266494-.79158298-.7474745-.84046115l-.0986794-.0056927Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19 19",
    fill: "none",
    id: "billing"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6304 8.80115H10.179V6.41142H11.434C11.9887 6.41142 12.4313 6.50626 12.7513 6.69403C13.055 6.87126 13.2035 7.16105 13.2035 7.58161C13.2035 7.79716 13.1632 7.98014 13.0828 8.12719C13.0028 8.27712 12.8921 8.4031 12.7542 8.50081C12.6133 8.6014 12.4452 8.67709 12.2531 8.72642C12.0553 8.77528 11.8469 8.80115 11.6304 8.80115ZM14.9135 10.6017C14.8144 10.3426 14.6712 10.1165 14.4911 9.92536C14.31 9.73615 14.0916 9.58192 13.8425 9.466C13.7165 9.4066 13.5838 9.35918 13.4454 9.32086C13.7491 9.18339 14.0068 8.99275 14.2142 8.74846C14.5097 8.40166 14.6592 7.96769 14.6592 7.46043C14.6592 7.02502 14.5734 6.65475 14.4048 6.36016C14.2362 6.06941 14.0144 5.828 13.7433 5.64741C13.4746 5.46923 13.1666 5.34037 12.8284 5.26373C12.495 5.18901 12.1578 5.15117 11.8244 5.15117H8.84638C8.77789 5.15117 8.72232 5.20673 8.72232 5.27475V11.4941C8.72232 11.5621 8.77789 11.6167 8.84638 11.6167H10.0549C10.123 11.6167 10.179 11.5621 10.179 11.4941V10.0738H11.6783C12.3096 10.0738 12.7963 10.1821 13.1254 10.3948C13.4411 10.6017 13.5939 10.9303 13.5939 11.4026C13.5939 11.6689 13.5369 11.8902 13.4253 12.0607C13.3093 12.2356 13.1599 12.373 12.9678 12.4789C12.7728 12.5862 12.552 12.6619 12.3111 12.7036C12.061 12.7467 11.8115 12.7692 11.5691 12.7692H8.58053L5.91771 12.7222V6.60685H7.09655C7.16601 6.60685 7.22062 6.55224 7.22062 6.48327V5.27475C7.22062 5.20673 7.16601 5.15117 7.09655 5.15117H4.58558C4.51756 5.15117 4.46199 5.20673 4.46199 5.27475V13.9178C4.46199 13.9863 4.51756 14.0419 4.58558 14.0419H11.6903C12.1482 14.0419 12.5832 13.9882 12.985 13.8848C13.3941 13.7799 13.7543 13.6213 14.0547 13.4149C14.3636 13.206 14.6113 12.9354 14.7895 12.6106C14.9706 12.2849 15.062 11.9003 15.062 11.4639C15.062 11.1482 15.0117 10.8584 14.9135 10.6017Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50072 17.6061C5.03058 17.6061 1.39488 13.97 1.39488 9.50048C1.39488 5.03045 5.03058 1.39437 9.50072 1.39437C13.9709 1.39437 17.6066 5.03045 17.6066 9.50048C17.6066 13.97 13.9709 17.6061 9.50072 17.6061ZM9.50072 0C4.26177 0 0 4.26166 0 9.50048C0 14.7388 4.26177 19 9.50072 19C14.7397 19 19 14.7388 19 9.50048C19 4.26166 14.7397 0 9.50072 0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "pin-angle",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146zm.122 2.112v-.002.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a4.507 4.507 0 0 0-.288-.076 4.922 4.922 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a4.924 4.924 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034.114 0 .23-.011.343-.04L9.927 2.028c-.029.113-.04.23-.04.343a1.779 1.779 0 0 0 .062.46z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "time-rows",
    viewBox: "0 0 17.66 12.25"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 6.12c0 3.11 2.52 5.62 5.62 5.62s5.62-2.52 5.62-5.62S9.23.5 6.12.5.5 3.02.5 6.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61 6.12H6.12V3.64"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 1.16h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.16 6.16h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16 11.16h4"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up",
    viewBox: "0 0 6 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3 0 3 4H0l3-4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 6 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3 4 3-4H0l3 4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 14",
    id: "arrow-return"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -7)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.498l-3-3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.498h6a3 3 0 003-3v-2a3 3 0 00-3-3H12"
  })))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 198 149.98",
    id: "generate-narrative",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.97 0 198 25.98l-2.01 1H13v84H0v-96h145.97V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.03 149.98 0 124l2.01-1H185V39h13v96H52.03v14.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78 94.27H77.39l-4.58 13.61H58.35l23.63-66.21h15.63l23.45 66.21h-15l-4.27-13.61Zm-3.86-11.41-8.27-26.05-8.54 26.05h16.8ZM125.33 41.67h13.75v66.21h-13.75V41.67Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "three-dots-vertical",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-tiles",
    fill: "currentColor",
    viewBox: "0 0 22.39 22.39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.34 22.39H2.06c-.83 0-2.06-.55-2.06-2.06V4.87c0-.83.55-2.06 2.06-2.06h18.28c.83 0 2.06.55 2.06 2.06v15.47c0 .83-.55 2.06-2.06 2.06Zm0-18.28H2.06c-.64 0-.75.48-.76.76v15.46c0 .64.48.75.76.76h18.27c.64 0 .75-.48.76-.76V4.87c0-.64-.48-.75-.76-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27 6.22c-.36 0-.65-.29-.65-.65V.65c0-.36.29-.65.65-.65s.65.29.65.65v4.92c0 .36-.29.65-.65.65ZM16.12 6.22c-.36 0-.65-.29-.65-.65V.65c0-.36.29-.65.65-.65s.65.29.65.65v4.92c0 .36-.29.65-.65.65ZM9.09 18.18H4.87c-.36 0-.65-.29-.65-.65v-4.22c0-.36.29-.65.65-.65h4.22c.36 0 .65.29.65.65v4.22c0 .36-.29.65-.65.65Zm-3.57-1.3h2.92v-2.92H5.52v2.92ZM13.31 18.18c-.36 0-.65-.29-.65-.65V9.09c0-.36.29-.65.65-.65s.65.29.65.65v8.44c0 .36-.29.65-.65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52 18.18H9.08c-.36 0-.65-.29-.65-.65V9.09c0-.36.29-.65.65-.65h8.44c.36 0 .65.29.65.65v8.44c0 .36-.29.65-.65.65Zm-7.79-1.3h7.14V9.74H9.73v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52 13.96H9.08c-.36 0-.65-.29-.65-.65s.29-.65.65-.65h8.44c.36 0 .65.29.65.65s-.29.65-.65.65Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "paper-plane",
    viewBox: "0 0 11 11"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26 7.11c-.34 0-.64-.22-.73-.54-.09-.32.04-.66.33-.83L9.33.61c.26-.16.58-.15.83.02.25.17.38.46.32.75L8.83 9.9c-.06.29-.28.52-.58.58s-.6-.04-.78-.28L5.08 7.11H1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09 7.11H3.94v2.3c0 .27.16.53.41.65.25.13.55.11.79-.04l1.46-.96-1.5-1.95ZM5.09 7.11 10.17.63"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "paper-plane-x",
    viewBox: "0 0 12.32 11.63"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.54 6.49-.8 4c-.1.3-.3.5-.6.6s-.6 0-.8-.3l-2.4-3.1h-3.7c-.3 0-.6-.2-.7-.5s0-.7.3-.8l4.6-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84 7.99v1.9c0 .3.2.5.4.7.2.1.6.1.8 0l1.2-.8M5.04 7.59l1.5-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.82.5 8.29 4.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.29.5 3.53 3.54"
  }))), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "exclamation-circle",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "grid-3x3-gap-fill",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "tags",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "translate",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "close-with-gutter",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow2",
    viewBox: "0 0 8 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 5 4-5H0z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "arrow-clockwise",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "clipboard",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "clipboard-check",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    id: "close-with-gutter",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSprite);
export default __webpack_public_path__ + "static/media/svg-sprite.35ca299acf559cb4568309490904fcb9.svg";
export { ForwardRef as ReactComponent };